<template lang="pug">
  .card-box.vld-parent
    Loading(v-bind:active.sync="views.loading" v-bind:can-cancel="false" v-bind:is-full-page="false")
    .m-b-20(v-for="account in views.accounts")
      h4.header-title {{ account.name }}
      .m-b-10(v-for="property in account.properties")
        h5 {{ property.name }}
        div(v-for="view in property.views")
          label.m-l-10.d-flex.align-items-center
            input.align-self-center.m-r-5(type="checkbox" v-model:checked="view.selected" v-on:change="updateSelected")
            span.align-self-center {{ view.name }}
            span.badge.badge-danger.m-l-5(v-if="view.selected") {{ $t('selected') }}
    button.btn.btn-primary(v-on:click="signIn")
      i.mdi.mdi-account-switch.m-r-5
      | {{ $t('switch-account') }}

</template>

<i18n>
{
  "ja": {
    "selected": "選択中",
    "switch-account": "アカウントを切り替え"
  },
  "en": {
    "selected": "SECTED",
    "switch-account": "Switch Account"
  }
}
</i18n>

<script>
import Loading from 'vue-loading-overlay'

export default {
  components: {
    Loading
  },
  data() {
    return {
    }
  },
  props: {
    views: Object,
  },
  methods: {
    signIn() {
      this.$emit('signIn')
    },
    updateSelected() {
      const selected = []
      this.views.accounts.forEach(account => {
        account.properties.forEach(property => {
          property.views.forEach(view => {
            if (view.selected) selected.push(view.id)
          })
        })
      })

      this.views.selected = selected
      window.localStorage.setItem('selectedViews', selected.join(','))
    }
  },
  async mounted() {
    this.$emit('mounted')
  }
}
</script>